// Base
import { BaseApi } from 'api/base.api'

// Interface
import {
  IHomeBannerApi,
  IHomeBannerApiRequest,
  IHomeBannerApiGetAllAttrs,
  IHomeBannerApiGetAllResponse,
  IHomeBannerApiGetAttrs,
  IHomeBannerApiGetResponse,
  IHomeBannerApiSaveAttrs,
  IHomeBannerApiSaveResponse,
} from 'interfaces/back-office/content-management/home/banner/home-banner-api.interface'
// eslint-disable-next-line
import { IBaseApiRequestPayload } from 'interfaces/api'

// Constant
import { ApiConstant } from 'constant'
import { HOME_BANNER, HOME_BANNERS } from 'constant/content-management/home/home-banner.constant'

// Utils
import { commonUtils_delay } from 'utils/common/common.utils'

export class HomeBannerApi extends BaseApi<IHomeBannerApi> implements IHomeBannerApiRequest {
  readonly url = ApiConstant.CONTENT_HOME_BANNER_URL

  /**
   * @description Get home banners
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IHomeBannerApiGetAllAttrs} payload
   *
   * @return {Promise<IHomeBannerApiGetAllResponse>} Promise<IHomeBannerApiGetAllResponse>
   */
  async homeBanner_getHomeBanners(payload: IHomeBannerApiGetAllAttrs): Promise<IHomeBannerApiGetAllResponse> {
    try {
      // const response = await this.POST('/', payload.body, { ...payload.requestConfig })

      await commonUtils_delay(300)

      return Promise.resolve(HOME_BANNERS)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Get home banner
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IHomeBannerApiGetAttrs} payload
   *
   * @return {Promise<IHomeBannerApiGetResponse>} Promise<IHomeBannerApiGetResponse>
   */
  async homeBanner_getHomeBanner(payload: IHomeBannerApiGetAttrs): Promise<IHomeBannerApiGetResponse> {
    try {
      // const response = await this.POST('/', payload.body, { ...payload.requestConfig })

      await commonUtils_delay(300)

      return Promise.resolve(HOME_BANNER)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Save home banner
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IHomeBannerApiSaveAttrs} payload
   *
   * @return {Promise<IHomeBannerApiSaveResponse>} Promise<IHomeBannerApiSaveResponse>
   */
  async homeBanner_saveHomeBanner(payload: IHomeBannerApiSaveAttrs): Promise<IHomeBannerApiSaveResponse> {
    try {
      // const requestPayload: IBaseApiRequestPayload = {
      //   method: payload.params?.id ? 'PUT' : 'POST',
      //   url: payload.params?.id ? `${this.url}/${payload.params.id}` : this.url,
      // }
      // const response = await this[requestPayload.method](requestPayload.url, {}, { ...payload.requestConfig })

      await commonUtils_delay(300)

      return Promise.resolve(HOME_BANNER)
    } catch (err) {
      return Promise.reject(err)
    }
  }
}
